// 20241016 xt I copied this from Report.js to try and make a new tab called Map
//      The Map tab page should look similar to the Reports tab except there will be a map on the 
//      incidents side that is has a pin for each incident loc instead of the list
// 20241028: xt I added some code from the Reports.js since it was missing and I want the MapTab.js to work like Reportss
// 20241101: xt I completely used the Report.js code and am modifying to get the map
// 20250717: xt change to use correct new token from auth gettokensiletnly
//
import React, { useState, useEffect, useRef } from 'react';
import { connect, useLoation, useSelector, useDispatch } from 'react-redux'; // xt dont know why this is here or where I got. maybe map.js
import PropTypes from "prop-types"; // xt propTypes SHOULD be used in large proj to document the expected types used
import { ClipLoader } from "react-spinners";
import { useAuth0 } from '@auth0/auth0-react';
import Select from "react-select"; // xt need to be aware of version since css below is not used in v2
import "react-datepicker/dist/react-datepicker.css";

// xt please leave this space. it reminds me that I want 'moment' taken out at some point
import moment from "moment";
import moments from "moment-timezone";
// xt leave this line space

// Utils
import { languageLabel } from "../../utils/Languages";
// Services
import LocalizationService from '../../utils/LocalizationService';
// Actions
import { fetchReportCSV, clearIsfetching } from "../../actions/csvReports"; // xt may not need?? from reports.js
import { requestStubs, selectAgencyId } from "../../actions/agencyStubs";
import { fetchAgency } from "../../actions/agency";
import { fetchReport } from '../../actions/report'; // returns a json, this is fetching the reportings collection NOT reportsummaries
import { clearMessages } from '../../actions/messages';
import { fetchReportSummaries, clearNewItem } from "../../actions/reportSummaries"; //xt I added this. not sure about clearnewitem
import { fetchResponderLocations } from '../../actions/responderLocations'; // xt this should not be needed

// Selectors
import { getVisibleReportSummaries } from "../../selectors/reports";

// Components
//import AgencySelector from '../../components/AgencySelector/AgencySelector'; // xt not sure why we need this here?
import AgencyList from "../../components/Agencies/AgencyList";
import MapTab from '../../components/MapTab/MapTab'; //xt 
import { useParams, useLocation } from 'react-router-dom';
//import Map from '../../components/Map/Map'; // map loooks like it is calling the google map but not sure of paramss
import './MapTabView.css';


const MapTabView = ({
  agencyStubs,
  agency,
  report,
  reportsummaries,
  isFetching,
  reportCSV,
  isFetchingcsv,
  reports,
  languages,
  current_language,
  totalPages,
  en_count,
  es_count,
  count,
  inc_types,
  timezones,
  error,
  languageCode,
  profile,
}) => {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const timeoutRef = useRef(null);

  // ✅ Get the agency ID from state to check if it's avail. may not be on hard refresh
  const agencyId = useSelector((state) => state.agencyStubs.selectedAgencyId);
  console.log("MTV= agencyId is line 75 ", agencyId);

  // ✅ Early exit: wait for agency details before rendering anything that depends on them
  if (!agency?.details?.report_name?.en_US) {
    return (
      <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status"></div>
        <p>Loading agency info...</p>
      </div>
    );
  }

  // xt these look initializers and like they are for controlling the left side filters
  const [state, setState] = useState({
    startDate: "",
    endDate: "",
    current_language: "en_US",
    checkboxvalue: [],
    checkboxStatusvalue: [],
    checkboxLanguagevalue: [],
    rowPerPage: 10,
    curPage: 1,
    totalPagesIN: 0,
    updatePageRow: 10,
    isFetching: false,
    csvReports: [],
    showLimitModal: false,
    timezone: "",
    /*New code added by GK 25-08-2023 to create scroll bars start*/
    width: window.innerWidth,
    height: window.innerHeight,
    /*New code added by GK 25-08-2023 end*/
  });

  /*New code added by GK 09-15-2023 to create scroll bars on report table start*/
  const updateWindowDimensions = () => {
    setState((prev) => ({
      ...prev,
      width: window.innerWidth,
      height: window.innerHeight - 100, // xt this was - 300 from GK but I am tryihg to make smaler
    }));
  };
  /*New code added by GK 09-15-2023 end*/

  // componentWillMount and componentDidMount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: 'openid profile email',
          },
        });
        console.log('MapTabView.js - Access token fetched:', token);

        if (!agencyStubs.selectedAgencyId && agencyStubs.items.length === 0) {
          dispatch(requestStubs(token));
        } else if (agencyStubs.selectedAgencyId && !agency.details._id) {
          dispatch(fetchAgency(agencyStubs.selectedAgencyId, token));
        }

        // xt this is named "prepare" but it actually does the fetch of the incidents too
        prepareFetch(agencyStubs.selectedAgencyId, token);
      } catch (err) {
        console.error('MapTabView.js - Failed to fetch token:', err);
        dispatch(setError(null, 'Token Error', 'Failed to authenticate. Please log in again.'));
      }
    };

    fetchInitialData();

    /*New code added by GK 09-15-2023 start*/
    setState((prev) => ({
      ...prev,
      width: window.innerWidth,
      height: window.innerHeight - 100, // xt is set to - 350, hum.. maybe I can make it smaller
    }));
    window.addEventListener("resize", updateWindowDimensions);
    /*New code added by GK 09-15-2023 end*/

    return () => {
      window.removeEventListener("resize", updateWindowDimensions);
      clearTimeout(timeoutRef.current);
    };
  }, [dispatch, getAccessTokenSilently, agencyStubs.selectedAgencyId, agencyStubs.items, agency.details._id]);


  // componentWillReceiveProps
  useEffect(() => {
    // xt need to see what these props are. dont know when it's called
    console.log("props in MapTabView =", { agencyStubs, report, reportsummaries });

    // xt not sure, this might be trying to find out if the button is clicked to export csv file
    if (reportCSV) {
      setState((prev) => ({
        ...prev,
        csvReports: reportCSV.items,
        isFetchingcsvv: isFetchingcsv,
      }));
    }

    if (!agencyStubs.selectedAgencyId) {
     const agencyId = agency?.agencyId || null;
      if (agencyId) {
        dispatch(selectAgencyId(agencyId));
      } else if (agencyStubs.items.length === 1) {
        dispatch(selectAgencyId(agencyStubs.items[0]._id));
      }
    }
    if (report.lastUpdated) {
      if (reports !== report.reports) {
        // console.log('REPORTComponent', 'not equal', report.isFetching)
        clearTimeout(timeoutRef.current);
        setState((prev) => ({
          ...prev,
          isFetching: report.isFetching,
        }));
        if (!report.isFetching) {
          if (!state.current_language && report.current_language) {
            setState((prev) => ({
              ...prev,
              current_language: report.current_language,
              totalPagesIN: report.totalPages,
            }));
          }
          // startPoll(agencyStubs.selectedAgencyId);
        }
      }
    } else {
      if (!report.isFetching) {
        prepareFetch(agencyStubs.selectedAgencyId);
      }
    }
  }, [
    dispatch,
    agencyStubs.selectedAgencyId,
    agencyStubs.items,
    reportCSV,
    isFetchingcsv,
    report.lastUpdated,
    report.isFetching,
    report.current_language,
    report.totalPages,
    reports,
    report.reports,
    timezones,
  ]);

  // startPoll(agencyId) {
  //   const { agencyStubs } = this.props;
  //   if (!agencyId) {
  //     agencyId = agencyStubs.selectAgencyId;
  //   }
  //   timeoutRef.current = setTimeout((filter) => {
  //     prepareFetch(agencyId);
  //   }, 10000);
  // }

  const prepareFetch = async (agencyId, token) => { // -------- xt this is MISNAMED is in NOT only the "PREPARE FETCH" but DOES the FETCH!!!!
    let dates = moment(state.endDate, "MM/DD/YYYY hh:mm:ss A").format(
      "MM/DD/YYYY HH:mm:ss"
    );
    // xt just to see if reports is there.
    console.log("pre fetch w/ reports ", reports);

    let formattedState = {
      start: state.startDate && moment(state.startDate).valueOf(),
      end:
        state.endDate &&
        moment(
          moment(dates)
            .add({
              hours: 23,
              minutes: 59,
              seconds: 59,
            })
            .format("MM/DD/YYYY HH:mm:ss")
        ).valueOf(),
      current_language: state.current_language,
      pageSize: state.rowPerPage,
      page: state.curPage,
      user_language: JSON.stringify(state.checkboxLanguagevalue),
      status_ids: JSON.stringify(state.checkboxStatusvalue),
      title: JSON.stringify(state.checkboxvalue),
    };
    const params = {};
    for (let queryParam of [
      "start",
      "end",
      "current_language",
      "pageSize",
      "page",
      "user_language",
      "status_ids",
      "title",
    ]) {
      if (formattedState[queryParam] !== undefined) {
        params[queryParam] = formattedState[queryParam];
      }
    }
    try {
      const tokenToUse = token || (await getAccessTokenSilently({
        authorizationParams: {
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: 'openid profile email',
        },
      }));
      console.log('MapTabView.js - Access token fetched for fetchReport:', tokenToUse);
      dispatch(fetchReport(agencyId, tokenToUse, params)); // xt this is where the GET for reportings happens
    } catch (err) {
      console.error('MapTabView.js - Failed to fetch token for fetchReport:', err);
      dispatch(setError(null, 'Token Error', 'Failed to authenticate. Please log in again.'));
    }
    console.log("after the fetchReport, props =", { agencyStubs, report, reportsummaries });
  };

  const handleTimezone = (data) => {
    setState((prev) => ({
      ...prev,
      timezone: data.value === "Select timezone" ? "" : data.value,
    }));
    console.log("timzone called");
  };

  const handleChange = (e) => {
    const tar = e.target.id;
    setState((prev) => ({
      ...prev,
      [tar]: e.target.value,
    }));
  };

  const handleStart = (e) => {
    setState((prev) => ({
      ...prev,
      startDate: e,
    }));
  };

  const handleEnd = (e) => {
    setState((prev) => ({
      ...prev,
      endDate: e,
    }));
  };

  const handleLanguageChange = (current_language_option) => {
    const current_language = current_language_option.value;
    setState((prev) => ({
      ...prev,
      current_language,
    }));
    clearTimeout(timeoutRef.current);
    prepareFetch(agencyStubs.selectedAgencyId);
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Incident type checkbox filter handler.
   */
  const handleCheckBox = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setState((prev) => ({
        ...prev,
        checkboxvalue: [...prev.checkboxvalue, e.target.value],
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    } else {
      const newCheckboxValue = [...state.checkboxvalue];
      const index = newCheckboxValue.indexOf(e.target.value);
      newCheckboxValue.splice(index, 1);
      setState((prev) => ({
        ...prev,
        checkboxvalue: newCheckboxValue,
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Status checkbox filter handler.
   */
  const handleStatusCheckBox = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setState((prev) => ({
        ...prev,
        checkboxStatusvalue: [...prev.checkboxStatusvalue, e.target.value],
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    } else {
      const newCheckboxStatusValue = [...state.checkboxStatusvalue];
      const index = newCheckboxStatusValue.indexOf(e.target.value);
      newCheckboxStatusValue.splice(index, 1);
      setState((prev) => ({
        ...prev,
        checkboxStatusvalue: newCheckboxStatusValue,
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  /**
   * @author Sultan
   * 03-03-2023
   * User language checkbox filter handler.
   */
  const handleCheckBoxLanguage = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setState((prev) => ({
        ...prev,
        checkboxLanguagevalue: [...prev.checkboxLanguagevalue, e.target.value],
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    } else {
      const newCheckboxLanguageValue = [...state.checkboxLanguagevalue];
      const index = newCheckboxLanguageValue.indexOf(e.target.value);
      newCheckboxLanguageValue.splice(index, 1);
      setState((prev) => ({
        ...prev,
        checkboxLanguagevalue: newCheckboxLanguageValue,
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Update page row size function.
   */
  const handlePageRow = (e) => {
    setState((prev) => ({
      ...prev,
      rowPerPage: e,
      updatePageRow: e,
    }), () => prepareFetch(agencyStubs.selectedAgencyId));
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Update page size function.
   */
  const handlePageSize = (e) => {
    if (e.target.value) {
      setState((prev) => ({
        ...prev,
        curPage: e.target.value,
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Pagination next handler.
   */
  const handleNext = () => {
    if (state.curPage !== totalPages && !state.isFetching) {
      setState((prev) => ({
        ...prev,
        curPage: prev.curPage + 1,
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  /**
   * @author Sultan
   * 03-03-2023
   * Pagination previous handler.
   */
  // xt somehow this is not rendering the map point markers correctly
  const handlePrev = () => {
    if (state.curPage > 1 && !state.isFetching) {
      setState((prev) => ({
        ...prev,
        curPage: prev.curPage - 1,
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  /**
   * @author Sultan
   * 03-03-2023
   * fetch export all data function.
   * below is the limit declared of how much data a user can export at a time.
   * Now Export limit as 500.
   */
  // xt may not need this in map tab.. or need to modify for the map printout
  // xt NOTE: this function is being passes as a prop to the child component, MapTab.js. Reports is doing the same thing
  //    need to find out how to change to make a print button instead of export button.
  //    it looks like this is controlling the incidents to be returned from DB so as to not exceed the 500 limit 
  //     we saw that over 500 had an impact on the backend and caused timeouts.. so we limit the inc # to 500 for each fetch
  const handleCsv = async () => {
    if (count <= 500) {
      let dates = moment(state.endDate, "MM/DD/YYYY hh:mm:ss A").format(
        "MM/DD/YYYY HH:mm:ss"
      );
      let formattedState = {
        start: state.startDate && moment(state.startDate).valueOf(),
        end:
          state.endDate &&
          moment(
            moment(dates)
              .add({
                hours: 23,
                minutes: 59,
                seconds: 59,
              })
              .format("MM/DD/YYYY HH:mm:ss")
          ).valueOf(),
        current_language: state.current_language,
        user_language: JSON.stringify(state.checkboxLanguagevalue),
        status_ids: JSON.stringify(state.checkboxStatusvalue),
        title: JSON.stringify(state.checkboxvalue),
      };
      const params = {};
      for (let queryParam of [
        "start",
        "end",
        "current_language",
        "user_language",
        "status_ids",
        "title",
      ]) {
        if (formattedState[queryParam] !== undefined) {
          params[queryParam] = formattedState[queryParam];
        }
      }
      /**
       * @author Sultan
       * 03-03-2023
       * create new file fetchReportCSV.
       */
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: 'openid profile email',
          },
        });
        console.log('MapTabView.js - Access token fetched for fetchReportCSV:', token);
        dispatch(fetchReportCSV(agencyStubs.selectedAgencyId, token, params));
      } catch (err) {
        console.error('MapTabView.js - Failed to fetch token for fetchReportCSV:', err);
        dispatch(setError(null, 'Token Error', 'Failed to authenticate. Please log in again.'));
      }
    } else {
      setState((prev) => ({
        ...prev,
        showLimitModal: true,
      }));
    }
  };

  /**
   * @author Sultan
   * 03-03-2023
   * clear all filter function
   */
  const handleclearAll = () => {
    if (
      state.checkboxvalue.length > 0 ||
      state.checkboxStatusvalue.length > 0 ||
      state.checkboxLanguagevalue.length > 0 ||
      state.startDate ||
      state.endDate
    ) {
      setState((prev) => ({
        ...prev,
        checkboxvalue: [],
        checkboxStatusvalue: [],
        checkboxLanguagevalue: [],
        startDate: "",
        endDate: "",
      }), () => prepareFetch(agencyStubs.selectedAgencyId));
    }
  };

  // xt setup the coord items to pin map on map.. I copied this from Responder.js
  // xt I DONT THINK THIS IS BEING USED ANYMORE ..THIS IS NOW BEING SET IN MAPTAB.JS.. CK IT
  
  console.log("inc_types", inc_types); // inc_types IS HERE!!! but not when sent to MapTab.js
  // console.log("agency details report name = ", agency.details.report_name.en_US);
  // console.log("reportsummaries = ", reportsummaries.items.coordinate.accuracy); // xt this is getting an undefined
  // xt just commenting out the code I copied in from responders..to get the coord.s
  console.log("agency.details.report_name:", agency?.details?.report_name); // xt this is 'incident' as report name
  const coordinatePoints = reports.map((data) => ({
    coordinates: {
      lat: Number(data.gps.replace(/Lat:|Long:/g, '').split(',')[0].trim()),
      lng: Number(data.gps.replace(/Lat:|Long:/g, '').split(',')[1].trim()),
    },
    markerColor: 
    data.report_status_id == "62d000000000000000000101" 
    ? "#FF0000" 
    : data.report_status_id == "62d000000000000000000102"
    ? "#00FF00" 
    : data.report_status_id == "62d000000000000000000103" 
    ? "#0000FF" 
    : "#FFFFFF",
   report_name: agency?.details?.report_name?.en_US || "Agency Name Unknown line 605",
    communications: data.messages,
    location: data.location,
    type: data.type,
    //typeOffset: Object.keys(inc_types).indexOf(data.type),
  }));

  // xt need to ck for agency defined or isFetching
  if (!agency.agencyId || agency.isFetching) {
    return (
      <div className="inMapTabViewCodeLine630"
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <ClipLoader
          cssOverride={{
            position: "absolute",
            top: "300px",
            left: "auto",
            right: "auto",
            zIndex: "99999",
          }}
          size={50}
          color="black"
        />
      </div>
    );
  }

  // if (!agencyStubs.selectedAgencyId && agencyStubs.items.length > 0) {
  //   return (
  //     <AgencyList
  //       pathRef="/dashboard"
  //       agencies={agencyStubs.items}
  //       languageCode={languageCode}
  //     />
  //   );
  // }

  if (!agencyStubs.selectedAgencyId) {
  console.error("MTV-line 619 Missing selected agency ID — app should have set this at login.");
  return <p className="text-danger">Error: No agency selected. Please log in again.</p>;
}


  return (
    <div className="maptab-container-fulldashboard665">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <div className="language" style={{ width: "10%" }}>
          <div style={{ width: "200px", paddingLeft: "1rem" }}>
            Language:
            <Select
              name="form-field-name"
              clearable={false}
              value={current_language}
              onChange={handleLanguageChange}
              options={["en_US", "es_US"].map((language) => ({
                value: language,
                label: languageLabel(language),
              }))}
              // options={languages.map((language) => ({
              //   value: language,
              //   label: languageLabel(language),
              // }))}
            />
          </div>
        </div>
        <div className="maptabview-line693" style={{ width: "90%", margin: "5px 0 1px" }}>
          <h2 className="fs-4 text-center my-3">
            {agency.details.name ? agency.details.name[languageCode] : null}
          </h2>
        </div>
      </div>

      <div className="maptab-container">
        {/* <div id='maptab-map-container'> */}
        {/* <AgencySelector pathRef='/responders' match={match} > */}
        {/* <Map coords={coordinatePoints} agency={agency} languageCode={languageCode} /> */}
        {/* </AgencySelector> */}

        <MapTab
          dispatch={dispatch}
          reports={reports}
          reportCSV={reportCSV.items}
          agency={agency}
          languageCode={languageCode}
          profile={profile}
          checkboxvalue={state.checkboxvalue}
          checkboxStatusvalue={state.checkboxStatusvalue}
          checkboxLanguagevalue={state.checkboxLanguagevalue}
          handleCheckBox={handleCheckBox}
          handleStatusCheckBox={handleStatusCheckBox}
          startDate={state.startDate}
          endDate={state.endDate}
          handleStart={handleStart}
          handleEnd={handleEnd}
          prepareFetch={() => prepareFetch(agencyStubs.selectedAgencyId)}
          page={state.curPage}
          handlePageRow={handlePageRow}
          totalPage={totalPages}
          updatePageRow={state.updatePageRow}
          handlePageSize={handlePageSize}
          handleNext={handleNext}
          handlePrev={handlePrev}
          handleCsv={handleCsv}
          handleclearAll={handleclearAll}
          handleCheckBoxLanguage={handleCheckBoxLanguage}
          isFetchingcsv={isFetchingcsv}
          isFetching={isFetching}
          en_count={en_count}
          es_count={es_count}
          count={count}
          inc_types={inc_types} // xt maybe should be this.inc_types???
          timezones={timezones}
          timezone={state.timezone}
          // handleExportModalClose={handleExportModalClose}
          showLimitModal={state.showLimitModal}
          handleTimezone={handleTimezone}
          // New code added by GK 09-15-2023 to create scrollbars on table start*/
          height={state.height}
          width={state.width}
          //New code added by GK 09-15-2023 end*/
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  console.log("🧠 MTV Full Redux state in mapStateToProps:", state);
  return {
    agencyStubs: state.agencyStubs || { items: [], selectedAgencyId: null },
    agency: state.agency || { details: {} },
    report: state.report || { reports: [], isFetching: false, current_language: "en_US", totalPages: null },
    reportsummaries: state.reportsummaries || {}, // xt I added this since I dont see coord in reports but do in rept sumaries
    isFetching: state.report.isFetching || false,
    reportCSV: state.reportCSV || { items: [] },
    isFetchingcsv: state.reportCSV.isFetchingcsv || "",
    reports: state.report.reports || [],
    languages: state.report.languages || [],
    current_language: state.report.current_language || "en_US",
    totalPages: state.report.totalPages || null,
    en_count: state.report.en_count || 0,
    es_count: state.report.es_count || 0,
    count: state.report.count || 0,
    inc_types: state.report.inc_types || [],
    timezones: state.report.timezones || [],
    error: state.error || null,
    languageCode: LocalizationService.getCurrentLanguage(),
    profile: state.profile || {},
  };
};

MapTabView.propTypes = {
  agencyStubs: PropTypes.shape({
    items: PropTypes.array,
    selectedAgencyId: PropTypes.string,
  }).isRequired,
  agency: PropTypes.shape({
    agencyId: PropTypes.string,
    isFetching: PropTypes.bool,
    details: PropTypes.object,
  }).isRequired,
  report: PropTypes.shape({
    reports: PropTypes.array,
    isFetching: PropTypes.bool,
    current_language: PropTypes.string,
    totalPages: PropTypes.number,
    languages: PropTypes.array,
    en_count: PropTypes.number,
    es_count: PropTypes.number,
    count: PropTypes.number,
    inc_types: PropTypes.array,
    timezones: PropTypes.array,
    lastUpdated: PropTypes.any,
  }).isRequired,
  reportsummaries: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired,
  reportCSV: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  isFetchingcsv: PropTypes.string.isRequired,
  reports: PropTypes.array.isRequired,
  languages: PropTypes.array.isRequired,
  current_language: PropTypes.string.isRequired,
  totalPages: PropTypes.number,
  en_count: PropTypes.number.isRequired,
  es_count: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  inc_types: PropTypes.array.isRequired,
  timezones: PropTypes.array.isRequired,
  error: PropTypes.object,
  languageCode: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(MapTabView);